export class Registro {
    id: number;
    idApp: number;
    idPublicacion:number;
    created: Date;
    error:boolean;
  
  }
  